import { Card } from '@components/atoms/Card';
import { Tab } from '@components/atoms/Tab';
import { TabsGroup } from '@components/TabsGroup';
import { useState } from 'react';
import { Home, Settings, Person } from '@mui/icons-material';

export const TabGroup = () => {
  const [activeTab, setActiveTab] = useState('home');

  const tabs = [
    {
      id: 'home',
      name: 'Home',
      leftIcon: <Home className="w-4 h-4" />,
      count: 5,
    },
    {
      id: 'profile',
      name: 'Profile',
      leftIcon: <Person className="w-4 h-4" />,
      count: 12,
    },
  ];

  const tabsWithContent = [
    {
      id: 'overview',
      name: 'Overview',
      leftIcon: <Home className="w-4 h-4" />,
      count: 5,
      content: (
        <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Overview Content
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            This is the overview tab content. You can put any React components
            here.
          </p>
        </div>
      ),
    },
    {
      id: 'analytics',
      name: 'Analytics',
      leftIcon: <Person className="w-4 h-4" />,
      count: 12,
      content: (
        <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Analytics Content
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            This is the analytics tab content with charts and data.
          </p>
        </div>
      ),
    },
    {
      id: 'settings',
      name: 'Settings',
      leftIcon: <Settings className="w-4 h-4" />,
      count: 3,
      content: (
        <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Settings Content
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            This is the settings tab content with configuration options.
          </p>
        </div>
      ),
    },
  ];
  return (
    <Card>
      <div className="flex flex-col gap-6">
        <h2 className="text-lg text-gray-900 dark:text-white font-bold">
          Tab Components
        </h2>

        {/* Underline Tabs */}
        <div className="space-y-4">
          <h3 className="text-md font-semibold text-gray-700 dark:text-gray-300">
            Underline Tabs
          </h3>
          <Tab
            tabs={tabs}
            variant="underline"
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />
        </div>

        {/* Pills Tabs */}
        <div className="space-y-4">
          <h3 className="text-md font-semibold text-gray-700 dark:text-gray-300">
            Pills Tabs
          </h3>
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            variant="pills"
            fullWidth
          />
        </div>

        {/* Default Tabs */}
        <div className="space-y-4">
          <h3 className="text-md font-semibold text-gray-700 dark:text-gray-300">
            Default Tabs
          </h3>
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            variant="default"
          />
        </div>

        {/* TabsGroup with Content */}
        <div className="space-y-4">
          <h3 className="text-md font-semibold text-gray-700 dark:text-gray-300">
            TabsGroup with Content
          </h3>
          <TabsGroup
            tabs={tabsWithContent}
            variant="underline"
            defaultActiveTab="overview"
          />
        </div>
      </div>
    </Card>
  );
};
